/**
 * Formats decimal hours (e.g. 1.5) into "1h 30m" or "30m".
 * @param {number} decimalHours 
 * @returns {string}
 */
export function fmtHours(decimalHours) {
  if (!decimalHours || isNaN(decimalHours)) return '0m';
  const totalMinutes = Math.round(decimalHours * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  
  if (h > 0) {
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
  }
  return `${m}m`;
}

/**
 * Formats seconds into "1h 30m" or "30m".
 * @param {number} seconds 
 * @returns {string}
 */
export function fmtDuration(seconds) {
  if (!seconds || isNaN(seconds)) return '0m';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  
  if (h > 0) {
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
  }
  return `${m}m`;
}
